/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseMediaList,
    PressReleaseMediaListFromJSON,
    PressReleaseMediaListFromJSONTyped,
    PressReleaseMediaListToJSON,
} from './PressReleaseMediaList';

/**
 * プレスリリース メディアリスト設定情報
 * @export
 * @interface PressReleaseMediaListData
 */
export interface PressReleaseMediaListData {
    /**
     * 自動選択の配信予定媒体数
     * @type {number}
     * @memberof PressReleaseMediaListData
     */
    autoSelectionListCount: number;
    /**
     * PR TIMESのメディアリスト一覧
     * @type {Array<PressReleaseMediaList>}
     * @memberof PressReleaseMediaListData
     */
    prtimes: Array<PressReleaseMediaList>;
    /**
     * インポートされたメディアリスト一覧
     * @type {Array<PressReleaseMediaList>}
     * @memberof PressReleaseMediaListData
     */
    imported: Array<PressReleaseMediaList>;
}

export function PressReleaseMediaListDataFromJSON(json: any): PressReleaseMediaListData {
    return PressReleaseMediaListDataFromJSONTyped(json, false);
}

export function PressReleaseMediaListDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseMediaListData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoSelectionListCount': json['auto_selection_list_count'],
        'prtimes': ((json['prtimes'] as Array<any>).map(PressReleaseMediaListFromJSON)),
        'imported': ((json['imported'] as Array<any>).map(PressReleaseMediaListFromJSON)),
    };
}

export function PressReleaseMediaListDataToJSON(value?: PressReleaseMediaListData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auto_selection_list_count': value.autoSelectionListCount,
        'prtimes': ((value.prtimes as Array<any>).map(PressReleaseMediaListToJSON)),
        'imported': ((value.imported as Array<any>).map(PressReleaseMediaListToJSON)),
    };
}

